import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

function Counter({ value, suffix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [n, setN] = useState(0);
  const target = parseInt(String(value).replace(/\D/g, ""), 10) || 0;
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const dur = 1400;
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setN(Math.floor(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);
  return <span ref={ref}>{n}{suffix}</span>;
}

export default function TrustMetrics({ site }) {
  const s = site || {};
  const items = [
    { big: <><Counter value={s.metric_students || "100"} suffix="+" /></>, label: "Students & Professionals Trained" },
    { big: s.metric_years || "3+ Years", label: "Training Experience" },
    { big: "Practical", label: "Interview-Focused Training" },
    { big: "Jodhpur", label: "Career Readiness Platform" },
  ];
  return (
    <section className="relative -mt-16 z-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="glass-light rounded-3xl shadow-high grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-slate-100">
          {items.map((it, i) => (
            <motion.div key={it.label} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
                        className="p-6 sm:p-8">
              <div className="font-display text-2xl sm:text-3xl font-semibold text-[#0B132B]">{it.big}</div>
              <div className="text-[13px] text-slate-500 mt-2 leading-snug">{it.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
